import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HandLookup } from '../../api/models';

export type TABLE_TYPE = Table<HandLookup>;

export const TABLE = 'handLookup';
const SCHEMA = 'handId, sortId';

class HandLookupDatabase implements DataRepository<HandLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HandLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HandLookup, key: Key): Promise<HandLookup> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HandLookup[]): Promise<HandLookup[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HandLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const HandLookupDB = new HandLookupDatabase(db);
